import { useEffect } from "react";

const ensureMetaTag = ({ name, property }) => {
  const selector = name
    ? `meta[name="${name}"]`
    : `meta[property="${property}"]`;
  let tag = document.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    if (name) {
      tag.setAttribute("name", name);
    }
    if (property) {
      tag.setAttribute("property", property);
    }
    document.head.appendChild(tag);
  }

  return tag;
};

const setMetaContent = ({ name, property, content }) => {
  if (!content) return;
  const tag = ensureMetaTag({ name, property });
  tag.setAttribute("content", content);
};

const usePageMeta = ({ title, description, keywords }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMetaContent({ property: "og:title", content: title });
    }
    if (description) {
      setMetaContent({ name: "description", content: description });
      setMetaContent({ property: "og:description", content: description });
    }
    if (keywords) {
      setMetaContent({ name: "keywords", content: keywords });
    }
  }, [title, description, keywords]);
};

export default usePageMeta;
